import { createContext, useCallback, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/core/context/keycloak.tsx
var KeycloakContext = createContext({
	keycloak: {},
	logout: void 0
});
var KeycloakProvider = ({ keycloak, logout, children }) => {
	const handleLogout = useCallback(async () => {
		try {
			keycloak.onAuthLogout?.();
			await logout?.();
		} catch (error) {
			console.error(error);
		}
	}, [logout, keycloak]);
	return /* @__PURE__ */ jsx(KeycloakContext.Provider, {
		value: {
			keycloak,
			logout: handleLogout
		},
		children
	});
};
var useKeycloak = () => useContext(KeycloakContext);
//#endregion
export { KeycloakContext, KeycloakProvider, useKeycloak };
